<template>
  <MainLayout>
    <div>
      <v-row align="center">
        <v-col cols="2">
          <CancelButton :project-id="projectId"/>
        </v-col>
        <v-col cols="8">
          <h1 style="text-align: center; margin-bottom: 10px;">New KPI Creation</h1>
        </v-col>
      </v-row>
      <div class="mt-7 mx-12">
        <KpiForm
            v-model="form"
            :project-id="projectId"
            :prototypes="prototypes"
            :kpis-types="kpiTypes"
            :accumulated-weights="accumulatedWeights"
            :default-kpi-values="defaultKpiValues"
            :ignored-weights="ignoredWeights"
            @submit="submit"
            @save="saveAndExit"
            class="ma-12" />
      </div>
    </div>
  </MainLayout>
</template>


<script setup>
import MainLayout from '@/Layouts/Main.vue'
import KpiForm from './Form.vue'
import * as $routes from '../../packs/routes'
import { router } from "@inertiajs/vue3";
import { ref } from 'vue'
import CancelButton from "@/Shared/CancelButton.vue";



const props = defineProps({
  projectId:{
    type: Number,
    required: true
  },
  kpi:{
    type: Object,
    required: true
  },
  sectors:{
    type: Array,
    required: true
  },
  sectorPrototype:{
    type: Object,
    required: true
  },
  dimension:{
    type: Object,
    required: true
  },
  aggregationLevelResults:{
    type: Object,
    required: true
  },
  aggregationPrototype: {
    type: Object,
    required: true
  },
  kpiTypes:{
    type: Array,
    required: true
  },
  defaultKpiValues:{
    type: Object,
    required: true
  },
  accumulatedWeights:{
    type: Object,
    required: false,
    default: null
  },
  ignoredWeights:{
    type: Array,
    required: false,
    default: function() {
      return []
    }
  }
})

let confirmCancel = ref(false);

const form = ref({
  kpi: props.kpi,
  sectors: props.sectors,
  dimension: props.dimension,
  aggregationLevels: []
})

const prototypes = {
  sector: props.sectorPrototype,
  aggregation: props.aggregationPrototype
}

function submit() {
  createSubmitObject(true)
  router.post($routes.project_kpis(props.projectId), form.value)
}

function saveAndExit() {
  createSubmitObject(false)
  router.post($routes.project_kpis(props.projectId), form.value)
}

function createSubmitObject(complete = true) {
  const sectors = form.value.kpi.sectors_attributes
  const levels = form.value.aggregationLevels
  const levelsAttrs = form.value.kpi.aggregation_levels_attributes
  
  sectors.forEach(function (sector,index){
    sector.aggregation_level_results_attributes = []
    const sectorKey = `sector_${sector.name}_weight`
    levels.forEach(function callbackFn(level, index){
      const aggObj = {
        name: level.name,
        value: level.value,
        weight: level[sectorKey]
      }
      sector.aggregation_level_results_attributes.push(aggObj)
    })
  })
  levels.forEach(function (level,index){
    const aggObj = {
      name: level.name,
      value: level.value
    }
    levelsAttrs.push(aggObj)
  })

  const dimension = form.value.kpi.dimension_attributes
  dimension.aggregation_level_results_attributes = []

  if (dimension.name){
    levels.forEach(function (level,index){
      const aggObj ={
        name: level.name,
        value: level.value,
        weight: level.dimension_weight
      }
      dimension.aggregation_level_results_attributes.push(aggObj)
    })
  }
  form.value.kpi.state = complete
}
</script>

<style scoped>

</style>
